import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UnaryFunction } from '@dice/app/types/dice.types';
import { TranslateService } from '@ngx-translate/core';
import { get as _get } from 'lodash';

@Component({
  selector: 'table-column-text',
  templateUrl: './table-column-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableColumnTextComponent<T> implements OnChanges {
  private translateService = inject(TranslateService);

  @Input() cssClass?: string | UnaryFunction<T, string>;

  @Input() displayValue?: UnaryFunction<T, string> | string;

  @Input() element: T;

  @Input() translation: string;

  @Input() tooltip?: string | UnaryFunction<T, string>;

  @Input() tooltipClass?: string | UnaryFunction<T, string> = 'multiline-tooltip';

  @Input() isHeader?: boolean; // unused, fixes console error after angular update

  @Input() type?: string; // unused, fixes console error after angular update

  @Input() columnCssClass?: string; // unused, fixes console error after angular update

  static readonly sortEnabled = true;

  displayedText: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    const { translation, element, cssClass, tooltip } = changes;
    if (translation || element) {
      this.displayContent();
    }
    if (cssClass && typeof this.cssClass === 'function') {
      const getCss = this.cssClass;
      this.cssClass = getCss(this.element);
    }
    if (tooltip && typeof this.tooltip === 'function') {
      const getTooltip = this.tooltip;
      this.tooltip = getTooltip(this.element);
    }
  }

  displayContent(): void {
    if (this.translation) {
      this.displayedText = this.translateService.instant(this.translation);
    }
    if (typeof this.displayValue === 'string') {
      this.displayedText = _get(this.element, this.displayValue);
    }
    if (typeof this.displayValue === 'function') {
      this.displayedText = this.displayValue(this.element);
    }
  }
}
